module.exports = __webpack_public_path__ + "static/img/product_society_society_znft.fa3b51d.svg";


//////////////////
// WEBPACK FOOTER
// ./static/img/product/product_society_society_znft.svg
// module id = yNrT
// module chunks = 0